import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './authForm.scss';

const AuthForm = ({children, className}) => <div className={classnames('auth-form', className)}>{children}</div>;

AuthForm.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

AuthForm.defaultProps = {
  className: '',
};

export default AuthForm;
